import React, { useEffect, useState } from 'react';
import { RouterProvider, useRevalidator } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import router from '@/router';
import ScreenOperator from '@/components/common/ScreenOperator';
import { useSessionStore } from '@/store';
import { env } from '@/constant/configure';
import delay from '@/utils/delay';
import { onLogoutBroadcast } from '@/utils/authBroadcast';
import { signOutSession } from '@/services/auth.service';
import { isSodomallPartnerDomain } from '@/utils/checkDomain';

if (env === 'prd') {
    const console: any = window.console || {};
    const methods = ['log', 'debug', 'warn', 'info'];
    methods.forEach((method) => {
        if (!!console[method]) console[method] = () => {};
    });
}

function App() {
    const { syncWithStorage } = useSessionStore();
    async function handleSession(ev: StorageEvent) {
        if (ev.key === 'flowing-manager-session') {
            const isRehydrated = await syncWithStorage(ev.newValue || '');
            if (isRehydrated)
                delay(300, () => {
                    router.revalidate();
                }).then((r) => r);
        }
    }

    useEffect(() => {
        // localStorage 변경 감지 (기존 로직)
        window.addEventListener('storage', handleSession);

        // BroadcastChannel로 로그아웃 메시지 감지 (다중 탭 동기화)
        const unsubscribe = onLogoutBroadcast(() => {
            // 다른 탭에서 로그아웃 시 현재 탭도 로그아웃 처리
            signOutSession().then(() => {
                // 소도몰 파트너 도메인인 경우 로그인 페이지로 이동
                if (isSodomallPartnerDomain()) {
                    window.location.href = '/login';
                } else {
                    window.location.reload();
                }
            });
        });

        return () => {
            window.removeEventListener('storage', handleSession);
            unsubscribe();
        };
    }, []);

    return (
        <HelmetProvider>
            <div className="App">
                {/* 타이틀/favicon은 ManagerLayout에서 사용자 역할에 따라 동적으로 설정됨 */}
                <RouterProvider router={router} fallbackElement={<ScreenOperator />} />
            </div>
        </HelmetProvider>
    );
}

export default App;
